export const tr = {
    'CollectionDefectIds.Gen.CANNOT_BE_EMPTY': '""Nerede aransın?" parametresi seçilmedi"',
    'DefectIds.NO_RIGHTS': 'Bu işlem için gerekli yetkiniz yok',
    'GdExceptions.ACCESS_DENIED': 'Bu sayfayı görüntüleme yetkiniz yok',
    'GdExceptions.NO_RIGHTS': 'Bu işlem için gerekli yetkiniz yok',
    'GdExceptions.TYCOON_SERVICE_UNAVAILABLE': "Hata oluştu: Yandex.Rehber'den veri alınamıyor",
    'KeywordDefectIds.Gen.NO_RIGHTS_IN_ARCHIVED_ADGROUP':
        'Arşiv gruplarındaki sözcükler değiştirilemez: {validationResultValue}',
    'KeywordDefectIds.Keyword.MAX_KEYWORDS_PER_AD_GROUP_EXCEEDED':
        'Grupta maksimum sözcük grubu sayısına ulaşıldı: {maxKeywords}',
    'PhraseDefectIds.Gen.BOTH_QUOTES_AND_MINUS_WORDS':
        'Tırnak içindeki sözcük grubu negatif anahtar sözcüklerden oluşamaz',
    'PhraseDefectIds.Gen.INVALID_EXCLAMATION_MARK': 'Negatif anahtar sözcükler geçersiz karakterler içeriyor',
    'PhraseDefectIds.Gen.INVALID_MINUS_MARK': 'Negatif anahtar sözcükler geçersiz karakterler içeriyor',
    'PhraseDefectIds.Gen.INVALID_PLUS_MARK': 'Sözcük grupları geçersiz karakterler içeriyor',
    'PhraseDefectIds.Gen.NO_PLUS_WORDS': 'Değişim yapılamaz: Anahtar sözcük grubu tamamen silinir',
    'PhraseDefectIds.String.ILLEGAL_CHARACTERS': 'Geçersiz karakterler girildi: {allinvalidSubstrings}',
    'PhraseDefectIds.String.NOT_SINGLE_MINUS_WORD':
        'Anahtar sözcük gruplarından sadece ayrı sözcükler çıkarılabilir, sözcük grupları çıkarılamaz: {phrase}',
    'PhraseDefectIds.String.TOO_LONG_MINUS_WORD':
        'Negatif anahtar sözcük için maksimum uzunluk: {maxLength}. {allinvalidSubstrings} negatif anahtar sözcüğü çok uzun.',
    'PhraseDefectIds.String.TOO_LONG_WORD':
        'Negatif anahtar sözcük grubu için maksimum uzunluk: {maxLength}. "{allinvalidSubstrings}" sözcük grubu çok uzun.',
    'PhraseDefectIds.String.TOO_MANY_WORDS': 'Sözcük grubunda maksimum sözcük sayısı: {maxWords}',
    'StringDefectIds.CANNOT_BE_EMPTY': 'Değişim yapılamaz: Anahtar sözcük grubu tamamen silinir',
    'phrase-only-stop-words': 'Anahtar sözcük grubu sadece stop sözcüklerden (bağlaç, edat vs.) oluşamaz',
    'unknown-error': 'Beklenmeyen hata',
    'unknown-error-title': 'Hata oluştu'
};
